import * as $ from 'jquery';

export const addToCart = () => {
    $('.add-to-cart-ajax').on('click', function (e) {
        e.preventDefault();

        const $btn = $(this);

        $.ajax({
            type: 'POST',
            url: localizedScript.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart'),
            data: {
                product_id: $btn.data('product_id'),
                quantity: $btn.data('quantity')
            },
            success: function (response) {

                if (response.error) return;

                if (response.fragments && response.fragments['.cart-count']) {
                    const temp = document.createElement('div');
                    temp.innerHTML = response.fragments['.cart-count'];

                    const newCount = temp.querySelector('.cart-count');

                    document.querySelectorAll('.cart-count').forEach(el => {
                        el.textContent = newCount.textContent;
                    });
                }
            }
        });
    });
}